import { Product } from "../classes/product";
import { PetType } from "../classes/petType";
import { Breed } from "../classes/breed";
import { PRODUCT_GROUP } from "../store/variables";

export function trackEvent(name: string, value: string | undefined): void {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ tierdaten: null });

    window.dataLayer.push({
      event: "select_" + name,
      tierdaten: {
        [name]: value,
      },
    });
  } catch (e) {
    console.error(e);
  }
}

export function trackObject(
  name: string,
  products: Product[],
  petType: PetType,
  petBreed: Breed,
  age: string
): void {
  try {
    if (products[0]?.final) {
      const items: Array<object> = [];
      products.forEach((product: Product) => {
        items.push({
          item_id: product.identifier,
          item_name: product.name,
          item_category: product.identifier,
          brand: "Agila",
          price: Number(product.price),
          quantity: 1,
        });
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: name,
        ecommerce: {
          item_list_id: products[products.length > 1 ? 1 : 0].identifier,
          item_list_name: products[products.length > 1 ? 1 : 0].name,
          tierart: petType.name,
          rasse: petBreed.name,
          alter: age,
          items: items,
        },
      });
    }
  } catch (e) {
    console.error(e);
  }
}

export function trackInitial(productGroup: number) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "tarifrechner",
      ecommerce: {
        currency: "EUR",
        value: 0,
        items: [
          {
            item_id: "XXXX",
            item_name: "Tierversicherung für Hunde und Katzen",
            affiliation: "xxxx",
            coupon: "xxxx",
            discount: 0,
            index: 0,
            item_brand: "Agila",
            item_category:
              productGroup === PRODUCT_GROUP.TKS
                ? "tierkrankenschutz"
                : productGroup === PRODUCT_GROUP.OPS
                ? "op-kostenschutz"
                : "haftpflichtschutz",
            item_category2: "",
            item_category3: "",
            item_category4: "",
            item_category5: "",
            item_list_id: "",
            item_list_name: "",
            item_variant: "",
            location_id: "",
            price: 0,
            quantity: 1,
          },
        ],
      },
    });
  } catch (e) {
    console.error(e);
  }
}
